import initAccordion from '../initAccordion';

document.addEventListener('DOMContentLoaded', (e) => {
  initAccordion();
});
